var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-none d-md-flex w-100 subheader",
      staticStyle: {
        "background-color": "#ededed",
        "min-height": "90px",
        "box-shadow": "inset 0 2px 2px rgba(0, 0, 0, 0.15)",
      },
    },
    [
      _c("div", { staticClass: "container-fluid position-relative" }, [
        _c("div", { staticClass: "row align-items-center my-links" }, [
          _c(
            "div",
            [
              _c(
                "router-link",
                {
                  class: { "link-active": !_vm.my && !_vm.favourites },
                  attrs: { to: "/panel/diagrams" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.clearFiltering.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        viewBox: "0 0 32 32",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M8 4v4H4V4zm2-2H2v8h8zm8 2v4h-4V4zm2-2h-8v8h8zm8 2v4h-4V4zm2-2h-8v8h8zM8 14v4H4v-4zm2-2H2v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zM8 24v4H4v-4zm2-2H2v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zm8 2v4h-4v-4zm2-2h-8v8h8z",
                          fill: "currentColor",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n          Slides library\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  class: { "link-active": _vm.my },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.loadMySlides.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        viewBox: "0 0 32 32",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M20 21h-8a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-4v2h8v-2z",
                          fill: "currentColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M28 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 24H6V12h20zm2-18H4V6h24v4z",
                          fill: "currentColor",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n          My slides\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  class: { "link-active": _vm.favourites },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.loadFavourites.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        viewBox: "0 0 32 32",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M22.45 6a5.47 5.47 0 0 1 3.91 1.64a5.7 5.7 0 0 1 0 8L16 26.13L5.64 15.64a5.7 5.7 0 0 1 0-8a5.48 5.48 0 0 1 7.82 0l2.54 2.6l2.53-2.58A5.44 5.44 0 0 1 22.45 6m0-2a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0a7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z",
                          fill: "currentColor",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n          My wishlist\n        "),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [_c("Search")], 1),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }